import { useCallback, useEffect, useMemo, useState } from 'react';
import { fetchDhtTexts } from './api';

export const LANGUAGE_STORAGE_KEY = 'selectedLanguage';
export const LANGUAGE_CHANGE_EVENT = 'dronehotel:languagechange';
const TEXT_ROWS_STORAGE_KEY = 'dhtTextRows';
const TEXT_ROWS_CHANGE_EVENT = 'dronehotel:textrowschange';

export const LANGUAGE_OPTIONS = [
  { code: 'NL', value: '1', label: 'Nederlands', helper: 'NL' },
  { code: 'EN', value: '2', label: 'English', helper: 'EN' },
  { code: 'FR', value: '3', label: 'Francais', helper: 'FR' },
  { code: 'DE', value: '4', label: 'Deutsch', helper: 'DE' }
];

const FALLBACK_LANGUAGE = 'EN';

const fallbackTranslations = {
  NL: {
    'Sign in with your Drone Hotel account': 'Inloggen met uw Drone Hotel-account',
    'Login': 'Inloggen',
    'Home': 'Home',
    'Map': 'Kaart',
    'Manual': 'Handleiding',
    'Logout': 'Uitloggen',
    'Open profile': 'Profiel openen',
    'Address unavailable': 'Adres niet beschikbaar',
    'Welcome to Drone Hotel, we are happy to have you here.': 'Welkom bij Drone Hotel, we zijn blij dat u er bent.',
    "Welcome to Drone Hotel, we're happy to have you here.": 'Welkom bij Drone Hotel, we zijn blij dat u er bent.',
    'View our locations': 'Bekijk onze locaties',
    'User Profile': 'Gebruikersprofiel',
    'Account details': 'Accountgegevens',
    'First name': 'Voornaam',
    'Last name': 'Achternaam',
    'Email': 'E-mail',
    'Username': 'Gebruikersnaam',
    'Role': 'Rol',
    'Organization': 'Organisatie',
    'Not available': 'Niet beschikbaar',
    'Language': 'Taal',
    'Choose display language': 'Kies weergavetaal',
    'Saving...': 'Opslaan...',
    'Saved': 'Opgeslagen',
    'Saved on this device': 'Opgeslagen op dit apparaat',
    'Select Organization & Role': 'Organisatie en rol selecteren',
    'Loading your organizations and roles...': 'Uw organisaties en rollen laden...',
    '-- Select an Organization --': '-- Selecteer een organisatie --',
    'No organizations available': 'Geen organisaties beschikbaar',
    '-- Select a Role --': '-- Selecteer een rol --',
    'No roles available': 'Geen rollen beschikbaar',
    'Continue': 'Doorgaan',
    'Please select both an organization and a role': 'Selecteer zowel een organisatie als een rol',
    'Selection saved successfully. Redirecting...': 'Selectie succesvol opgeslagen. U wordt doorgestuurd...',
    'Failed to save your selection. Please try again.': 'Uw selectie kon niet worden opgeslagen. Probeer het opnieuw.',
    'Quick Navigation': 'Snelle navigatie',
    'Overview': 'Overzicht',
    'Admin Tools': 'Admin-tools',
    'Reservation Panel': 'Reserveringspaneel',
    'Active Boxes': 'Actieve boxen',
    'Components': 'Componenten',
    'Hotels': 'Hotels',
    'Flight Plan': 'Vluchtplan',
    'Box Availability': 'Boxbeschikbaarheid',
    'Expand': 'Uitklappen',
    'Collapse': 'Inklappen',
    'Expand navigation menu': 'Navigatiemenu uitklappen',
    'Collapse navigation menu': 'Navigatiemenu inklappen',
    'Hotel operations, weather, and live box activity in one dashboard.': 'Hoteloperaties, weer en live boxactiviteit in een dashboard.',
    'Weather': 'Weer',
    'Rooms': 'Kamers',
    'Total Capacity': 'Totale capaciteit',
    'Total Boxes': 'Totaal aantal boxen',
    'Active Units': 'Actieve eenheden',
    'Boxes assigned to this hotel': 'Boxen toegewezen aan dit hotel',
    'Available boxes now': 'Nu beschikbare boxen',
    'Access Level': 'Toegangsniveau',
    'User': 'Gebruiker',
    'Connected to this hotel': 'Verbonden met dit hotel',
    'Control Center': 'Controlecentrum',
    'Reservation Center': 'Reserveringscentrum',
    'Inspect and manage boxes from a single workspace.': 'Inspecteer en beheer boxen vanuit een centrale werkruimte.',
    'Reserve and review boxes available in this hotel.': 'Reserveer en bekijk boxen die in dit hotel beschikbaar zijn.',
    'Live box slots currently connected to this hotel.': 'Live boxplaatsen die momenteel met dit hotel zijn verbonden.',
    'Refresh Status': 'Status vernieuwen',
    'No boxes currently assigned to this location.': 'Geen boxen momenteel toegewezen aan deze locatie.',
    'Return to Map': 'Terug naar kaart',
    'Back to Map': 'Terug naar kaart',
    'Error': 'Fout'
  },
  FR: {
    'Sign in with your Drone Hotel account': 'Connectez-vous avec votre compte Drone Hotel',
    'Login': 'Connexion',
    'Home': 'Accueil',
    'Map': 'Carte',
    'Manual': 'Manuel',
    'Logout': 'Deconnexion',
    'Open profile': 'Ouvrir le profil',
    'Address unavailable': 'Adresse indisponible',
    'Welcome to Drone Hotel, we are happy to have you here.': 'Bienvenue chez Drone Hotel, nous sommes heureux de vous accueillir.',
    "Welcome to Drone Hotel, we're happy to have you here.": 'Bienvenue chez Drone Hotel, nous sommes heureux de vous accueillir.',
    'View our locations': 'Voir nos sites',
    'User Profile': 'Profil utilisateur',
    'Account details': 'Details du compte',
    'First name': 'Prenom',
    'Last name': 'Nom',
    'Email': 'E-mail',
    'Username': 'Nom d utilisateur',
    'Role': 'Role',
    'Organization': 'Organisation',
    'Not available': 'Non disponible',
    'Language': 'Langue',
    'Choose display language': 'Choisir la langue d affichage',
    'Saving...': 'Enregistrement...',
    'Saved': 'Enregistre',
    'Saved on this device': 'Enregistre sur cet appareil',
    'Select Organization & Role': 'Selectionner une organisation et un role',
    'Loading your organizations and roles...': 'Chargement de vos organisations et roles...',
    '-- Select an Organization --': '-- Selectionnez une organisation --',
    'No organizations available': 'Aucune organisation disponible',
    '-- Select a Role --': '-- Selectionnez un role --',
    'No roles available': 'Aucun role disponible',
    'Continue': 'Continuer',
    'Please select both an organization and a role': 'Veuillez selectionner une organisation et un role',
    'Selection saved successfully. Redirecting...': 'Selection enregistree avec succes. Redirection...',
    'Failed to save your selection. Please try again.': 'Impossible d enregistrer votre selection. Veuillez reessayer.',
    'Quick Navigation': 'Navigation rapide',
    'Overview': 'Apercu',
    'Admin Tools': 'Outils admin',
    'Reservation Panel': 'Panneau de reservation',
    'Active Boxes': 'Box actives',
    'Components': 'Composants',
    'Hotels': 'Hotels',
    'Flight Plan': 'Plan de vol',
    'Box Availability': 'Disponibilite des box',
    'Expand': 'Etendre',
    'Collapse': 'Reduire',
    'Expand navigation menu': 'Etendre le menu de navigation',
    'Collapse navigation menu': 'Reduire le menu de navigation',
    'Hotel operations, weather, and live box activity in one dashboard.': 'Operations hotelieres, meteo et activite des box en direct dans un seul tableau de bord.',
    'Weather': 'Meteo',
    'Rooms': 'Chambres',
    'Total Capacity': 'Capacite totale',
    'Total Boxes': 'Total des box',
    'Active Units': 'Unites actives',
    'Boxes assigned to this hotel': 'Box affectees a cet hotel',
    'Available boxes now': 'Box disponibles maintenant',
    'Access Level': 'Niveau d acces',
    'User': 'Utilisateur',
    'Connected to this hotel': 'Connecte a cet hotel',
    'Control Center': 'Centre de controle',
    'Reservation Center': 'Centre de reservation',
    'Inspect and manage boxes from a single workspace.': 'Inspectez et gerez les box depuis un espace de travail unique.',
    'Reserve and review boxes available in this hotel.': 'Reservez et consultez les box disponibles dans cet hotel.',
    'Live box slots currently connected to this hotel.': 'Emplacements de box actuellement connectes a cet hotel.',
    'Refresh Status': 'Actualiser le statut',
    'No boxes currently assigned to this location.': 'Aucune box actuellement affectee a cet emplacement.',
    'Return to Map': 'Retour a la carte',
    'Back to Map': 'Retour a la carte',
    'Error': 'Erreur'
  },
  DE: {
    'Sign in with your Drone Hotel account': 'Melden Sie sich mit Ihrem Drone Hotel-Konto an',
    'Login': 'Anmelden',
    'Home': 'Startseite',
    'Map': 'Karte',
    'Manual': 'Handbuch',
    'Logout': 'Abmelden',
    'Open profile': 'Profil oeffnen',
    'Address unavailable': 'Adresse nicht verfuegbar',
    'Welcome to Drone Hotel, we are happy to have you here.': 'Willkommen bei Drone Hotel, wir freuen uns, dass Sie hier sind.',
    "Welcome to Drone Hotel, we're happy to have you here.": 'Willkommen bei Drone Hotel, wir freuen uns, dass Sie hier sind.',
    'View our locations': 'Unsere Standorte ansehen',
    'User Profile': 'Benutzerprofil',
    'Account details': 'Kontodetails',
    'First name': 'Vorname',
    'Last name': 'Nachname',
    'Email': 'E-Mail',
    'Username': 'Benutzername',
    'Role': 'Rolle',
    'Organization': 'Organisation',
    'Not available': 'Nicht verfuegbar',
    'Language': 'Sprache',
    'Choose display language': 'Anzeigesprache waehlen',
    'Saving...': 'Speichern...',
    'Saved': 'Gespeichert',
    'Saved on this device': 'Auf diesem Geraet gespeichert',
    'Select Organization & Role': 'Organisation und Rolle auswaehlen',
    'Loading your organizations and roles...': 'Ihre Organisationen und Rollen werden geladen...',
    '-- Select an Organization --': '-- Organisation auswaehlen --',
    'No organizations available': 'Keine Organisationen verfuegbar',
    '-- Select a Role --': '-- Rolle auswaehlen --',
    'No roles available': 'Keine Rollen verfuegbar',
    'Continue': 'Weiter',
    'Please select both an organization and a role': 'Bitte waehlen Sie eine Organisation und eine Rolle aus',
    'Selection saved successfully. Redirecting...': 'Auswahl erfolgreich gespeichert. Weiterleitung...',
    'Failed to save your selection. Please try again.': 'Ihre Auswahl konnte nicht gespeichert werden. Bitte erneut versuchen.',
    'Quick Navigation': 'Schnellnavigation',
    'Overview': 'Uebersicht',
    'Admin Tools': 'Admin-Tools',
    'Reservation Panel': 'Reservierungsbereich',
    'Active Boxes': 'Aktive Boxen',
    'Components': 'Komponenten',
    'Hotels': 'Hotels',
    'Flight Plan': 'Flugplan',
    'Box Availability': 'Box-Verfuegbarkeit',
    'Expand': 'Ausklappen',
    'Collapse': 'Einklappen',
    'Expand navigation menu': 'Navigationsmenue ausklappen',
    'Collapse navigation menu': 'Navigationsmenue einklappen',
    'Hotel operations, weather, and live box activity in one dashboard.': 'Hotelbetrieb, Wetter und Live-Box-Aktivitaet in einem Dashboard.',
    'Weather': 'Wetter',
    'Rooms': 'Zimmer',
    'Total Capacity': 'Gesamtkapazitaet',
    'Total Boxes': 'Boxen gesamt',
    'Active Units': 'Aktive Einheiten',
    'Boxes assigned to this hotel': 'Diesem Hotel zugewiesene Boxen',
    'Available boxes now': 'Jetzt verfuegbare Boxen',
    'Access Level': 'Zugriffsebene',
    'User': 'Benutzer',
    'Connected to this hotel': 'Mit diesem Hotel verbunden',
    'Control Center': 'Kontrollzentrum',
    'Reservation Center': 'Reservierungszentrum',
    'Inspect and manage boxes from a single workspace.': 'Boxen in einem zentralen Arbeitsbereich pruefen und verwalten.',
    'Reserve and review boxes available in this hotel.': 'In diesem Hotel verfuegbare Boxen reservieren und pruefen.',
    'Live box slots currently connected to this hotel.': 'Live-Box-Plaetze, die aktuell mit diesem Hotel verbunden sind.',
    'Refresh Status': 'Status aktualisieren',
    'No boxes currently assigned to this location.': 'Diesem Standort sind derzeit keine Boxen zugewiesen.',
    'Return to Map': 'Zurueck zur Karte',
    'Back to Map': 'Zurueck zur Karte',
    'Error': 'Fehler'
  }
};

const getTextValue = (row, languageCode) => row?.[`DHTT_text_${languageCode}`] || '';

const normalizeTextRows = (rows) => {
  const resolvedRows = Array.isArray(rows)
    ? rows
    : rows?.rows || rows?.data || rows?.texts || rows?.translations || [];

  if (!Array.isArray(resolvedRows)) {
    return [];
  }

  return resolvedRows.filter((row) => row?.DHTT_text_EN);
};

const buildTranslationsFromRows = (rows) => {
  const nextTranslations = { NL: {}, FR: {}, DE: {} };

  normalizeTextRows(rows).forEach((row) => {
    const englishText = getTextValue(row, 'EN');

    if (!englishText) {
      return;
    }

    ['NL', 'FR', 'DE'].forEach((languageCode) => {
      const translatedText = getTextValue(row, languageCode);
      if (translatedText) {
        nextTranslations[languageCode][englishText] = translatedText;
      }
    });
  });

  return nextTranslations;
};

const getStoredTextRows = () => {
  try {
    return normalizeTextRows(JSON.parse(localStorage.getItem(TEXT_ROWS_STORAGE_KEY) || '[]'));
  } catch {
    return [];
  }
};

let textRowsPromise = null;
let hasReportedTextRowsError = false;

export const loadDhtTextRows = async () => {
  if (!textRowsPromise) {
    textRowsPromise = fetchDhtTexts()
      .then((rows) => {
        const normalizedRows = normalizeTextRows(rows);
        localStorage.setItem(TEXT_ROWS_STORAGE_KEY, JSON.stringify(normalizedRows));
        window.dispatchEvent(new CustomEvent(TEXT_ROWS_CHANGE_EVENT));
        return normalizedRows;
      })
      .catch((error) => {
        textRowsPromise = null;
        throw error;
      });
  }

  return textRowsPromise;
};

export const isSupportedLanguage = (languageCode) => (
  LANGUAGE_OPTIONS.some((language) => language.code === languageCode)
);

export const getLanguageByCode = (languageCode) => (
  LANGUAGE_OPTIONS.find((language) => language.code === languageCode)
);

export const getLanguageCodeFromPreferenceValue = (preferenceValue) => (
  LANGUAGE_OPTIONS.find((language) => String(language.value) === String(preferenceValue))?.code || null
);

export const getStoredLanguage = () => {
  const storedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  return isSupportedLanguage(storedLanguage) ? storedLanguage : FALLBACK_LANGUAGE;
};

export const setStoredLanguage = (languageCode) => {
  const nextLanguage = isSupportedLanguage(languageCode) ? languageCode : FALLBACK_LANGUAGE;
  localStorage.setItem(LANGUAGE_STORAGE_KEY, nextLanguage);
  window.dispatchEvent(new CustomEvent(LANGUAGE_CHANGE_EVENT, { detail: { language: nextLanguage } }));
  return nextLanguage;
};

export const translate = (languageCode, text) => {
  if (!text) return text;
  if (languageCode === FALLBACK_LANGUAGE) return text;
  const tableTranslations = buildTranslationsFromRows(getStoredTextRows());
  return tableTranslations[languageCode]?.[text] || fallbackTranslations[languageCode]?.[text] || text;
};

export const useTranslation = () => {
  const [language, setLanguageState] = useState(getStoredLanguage);
  const [textRows, setTextRows] = useState(getStoredTextRows);

  useEffect(() => {
    const handleLanguageChange = (event) => {
      setLanguageState(event?.detail?.language || getStoredLanguage());
    };
    const handleStorageChange = (event) => {
      if (event.key === LANGUAGE_STORAGE_KEY) {
        setLanguageState(getStoredLanguage());
      }

      if (event.key === TEXT_ROWS_STORAGE_KEY) {
        setTextRows(getStoredTextRows());
      }
    };
    const handleTextRowsChange = () => {
      setTextRows(getStoredTextRows());
    };

    window.addEventListener(LANGUAGE_CHANGE_EVENT, handleLanguageChange);
    window.addEventListener(TEXT_ROWS_CHANGE_EVENT, handleTextRowsChange);
    window.addEventListener('storage', handleStorageChange);
    loadDhtTextRows().catch((error) => {
      if (!hasReportedTextRowsError) {
        hasReportedTextRowsError = true;
        console.info('DHT_Text endpoint is not available yet; using bundled fallback translations.', error);
      }
    });

    return () => {
      window.removeEventListener(LANGUAGE_CHANGE_EVENT, handleLanguageChange);
      window.removeEventListener(TEXT_ROWS_CHANGE_EVENT, handleTextRowsChange);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const tableTranslations = useMemo(() => buildTranslationsFromRows(textRows), [textRows]);
  const setLanguage = useCallback((languageCode) => {
    setLanguageState(setStoredLanguage(languageCode));
  }, []);
  const t = useCallback((text) => {
    if (!text) return text;
    if (language === FALLBACK_LANGUAGE) return text;
    return tableTranslations[language]?.[text] || fallbackTranslations[language]?.[text] || text;
  }, [language, tableTranslations]);

  return useMemo(() => ({
    language,
    setLanguage,
    t
  }), [language, setLanguage, t]);
};
